export const domainCategories = [
    { name: 'Select Domain', id: -1 },
    { name: 'Premium domains', id: 3 },
    { name: 'Blacklisted domains', id: 1 },
    { name: 'Paid client domains', id: 2 }
]